var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"unverified"}},[(!_vm.error)?_c('nuxt'):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"error-getting-events"},[_c('small',[_vm._v("There was a problem retrieving events, please contact S-8.")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }